// Nos réalisations et références techniques
// Photos réelles d'installations et d'interventions de NANDA SÁ ENERGIA PRO.
// Aucune donnée confidentielle (client, adresse, puissance, marque non confirmée) n'est mentionnée.
import { l } from "@/i18n/helpers";

export const REALISATIONS = [
 {
 slug: "reception-equipements-frigorifiques",
 src: "/photos/realisations/refrigeration-01-reception-palettes.webp",
 alt: l(
 "Réception d'équipements frigorifiques sur palettes, préparation d'un chantier de chambre froide en Afrique de l'Ouest",
 "Reception of refrigeration equipment on pallets, preparing a cold room project in West Africa",
 "Recepção de equipamentos frigoríficos em paletes, preparação de uma obra de câmara fria na África Ocidental"
 ),
 caption: l(
 "Réception des équipements frigorifiques.",
 "Reception of the refrigeration equipment.",
 "Recepção dos equipamentos frigoríficos."
 ),
 description: l(
 "Préparation d'un chantier : contrôle, tri et mise à disposition du matériel avant installation. Notre équipe assure la logistique et la chaîne d'approvisionnement en amont du montage.",
 "Preparation of a project: check, sorting and staging of equipment before installation. Our team handles logistics and the supply chain upstream of the assembly.",
 "Preparação de uma obra: controlo, triagem e disponibilização do material antes da instalação. A nossa equipa assegura a logística e a cadeia de abastecimento a montante da montagem."
 ),
 },
 {
 slug: "chambre-froide-evaporateurs",
 src: "/photos/realisations/refrigeration-02-chambre-froide-evaporateurs.webp",
 alt: l(
 "Vue intérieure d'une chambre froide équipée de plusieurs évaporateurs, installation industrielle en Afrique de l'Ouest",
 "Interior view of a cold room fitted with several evaporators, industrial installation in West Africa",
 "Vista interior de uma câmara fria equipada com vários evaporadores, instalação industrial na África Ocidental"
 ),
 caption: l(
 "Chambre froide industrielle, plusieurs évaporateurs en service.",
 "Industrial cold room, multiple evaporators in service.",
 "Câmara fria industrial, vários evaporadores em serviço."
 ),
 description: l(
 "Installation industrielle en fonctionnement. Le dimensionnement thermique et la disposition des évaporateurs garantissent une température homogène et stable dans l'ensemble du volume.",
 "Industrial installation in operation. Thermal sizing and the layout of evaporators guarantee a homogeneous, stable temperature throughout the volume.",
 "Instalação industrial em funcionamento. O dimensionamento térmico e a disposição dos evaporadores garantem uma temperatura homogénea e estável em todo o volume."
 ),
 },
 {
 slug: "groupes-exterieurs-raccordement",
 src: "/photos/realisations/refrigeration-03-groupes-exterieurs-raccordement.webp",
 alt: l(
 "Groupes extérieurs frigorifiques et raccordement frigorifique en toiture, projet industriel",
 "Outdoor refrigeration condensing units and cooling piping connection on a rooftop, industrial project",
 "Grupos exteriores frigoríficos e ligação frigorífica em cobertura, projecto industrial"
 ),
 caption: l(
 "Groupes extérieurs et raccordement frigorifique.",
 "Outdoor units and cooling piping connection.",
 "Grupos exteriores e ligação frigorífica."
 ),
 description: l(
 "Mise en place des groupes de condensation extérieurs et raccordement des liaisons frigorifiques. La qualité de la brasure, l'étanchéité et l'isolation sont contrôlées à chaque étape.",
 "Installation of outdoor condensing units and connection of refrigerant lines. Brazing quality, sealing and insulation are checked at every step.",
 "Colocação dos grupos de condensação exteriores e ligação das linhas frigoríficas. A qualidade da soldadura, a estanquidade e o isolamento são controlados a cada etapa."
 ),
 },
 {
 slug: "intervention-hauteur",
 src: "/photos/realisations/refrigeration-04-intervention-hauteur.webp",
 alt: l(
 "Intervention technique en hauteur sur un évaporateur en chambre froide, sécurité et EPI en Afrique de l'Ouest",
 "Technical intervention at height on a cold-room evaporator, safety and PPE in West Africa",
 "Intervenção técnica em altura sobre um evaporador em câmara fria, segurança e EPI na África Ocidental"
 ),
 caption: l(
 "Intervention en hauteur sur un évaporateur.",
 "Intervention at height on an evaporator.",
 "Intervenção em altura sobre um evaporador."
 ),
 description: l(
 "Maintenance ou finalisation d'installation en hauteur. Toutes nos interventions respectent les protocoles de sécurité et l'usage des équipements de protection individuelle.",
 "Maintenance or final installation at height. All our interventions follow safety protocols and the use of personal protective equipment.",
 "Manutenção ou finalização de instalação em altura. Todas as nossas intervenções cumprem os protocolos de segurança e o uso de equipamento de protecção individual."
 ),
 },
 {
 slug: "reseaux-tuyauterie",
 src: "/photos/realisations/refrigeration-05-reseaux-tuyauterie.webp",
 alt: l(
 "Réseaux de tuyauterie frigorifique et installation technique, chantier de réfrigération industrielle en Afrique de l'Ouest",
 "Refrigeration piping networks and technical installation, industrial refrigeration project in West Africa",
 "Redes de tubagem frigorífica e instalação técnica, obra de refrigeração industrial na África Ocidental"
 ),
 caption: l(
 "Réseaux de tuyauterie et installation technique.",
 "Piping networks and technical installation.",
 "Redes de tubagem e instalação técnica."
 ),
 description: l(
 "Vue d'ensemble d'un local technique : réseaux de tuyauterie, isolation frigorifique et circuits de contrôle. Le cheminement propre facilite la maintenance et la traçabilité.",
 "Overall view of a plant room: piping networks, cooling insulation and control circuits. Clean routing makes maintenance and traceability easier.",
 "Vista de conjunto de uma casa técnica: redes de tubagem, isolamento frigorífico e circuitos de controlo. O encaminhamento limpo facilita a manutenção e a rastreabilidade."
 ),
 },
];
